<template>
  <SettingsGetter />
  <slot />
</template>
